import $ from 'jquery';
import 'slick-carousel';
import BaseComponent from './baseComponent';

/**
 * The slider used in the newsroom to present top news, based on slick slider.
 * http://kenwheeler.github.io/slick/
 */
export default class TeaserCarousel extends BaseComponent {
  /**
     * Public constructor
     *
     * @param options
     */
  constructor(options) {
    super(options);
    this.$slider = $('[data-teaser-carousel]');
  }

  /**
     * Initialize the slider.
     */
  init() {
    if (!this.$slider.length) {
      return;
    }

    this.$slider.slick({
      arrows: false,
      centerPadding: '20px',
      slidesToShow: 5,
      adaptiveHeight: false,
      autoplaySpeed: 2000,
      centerMode: false,
      responsive: [
        {
          breakpoint: 1360,
          settings: {
            slidesToShow: 4,
            centerMode: false,
          },
        },
        {
          breakpoint: 1100,
          settings: {
            slidesToShow: 3,
            centerMode: false,
          },
        },
        {
          breakpoint: 850,
          settings: {
            slidesToShow: 2,
            centerMode: false,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            centerMode: true,
          },
        },
      ],
    })
      .on('setPosition', (event, slick) => {
        slick.$slides.css('height', `${slick.$slideTrack.height()}px`);
      });

    // In viewport...
    const $modules = [...document.querySelectorAll('[data-teaser-carousel]')];

    const options = {
      root: null,
      threshold: 0,
      rootMargin: '0px 0px -450px 0px',
    };

    const pageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return;
        }

        entry.target.classList.toggle('-in-viewport');

        setTimeout(() => {
          this.$slider.slick('slickPlay');
        }, 3000);

        observer.unobserve(entry.target);
      });
    }, options);

    $modules.forEach((module) => {
      pageObserver.observe(module);
    });
  }
}
